import * as React from "react";

import ComponentPage from "../../Components/ComponentPage";
import Usage from "../../Docs/Components/Persona/PersonaUsage.mdx";

import Examples from "../../Docs/Components/Persona/PersonaExamples";
        
class Page extends React.Component {
public render() {
    return (
        <ComponentPage
            name="Persona"
            description="Persona renders icons representing people or groups."
            apiSources={["azure-devops-ui/Components/VssPersona/VssPersona.Props.d.ts"]}
            examples={Examples}
            status={{"design":"done","code":"done","docs":"Planned (Q3)"}}
            usage={Usage}
        />
    );
}
}
        
export default Page;